import React from 'react';
import { Button } from '../../../../ui/components/Common/Buttons/Button';

const PermissionsTab = () => {
  const roles = [
    {
      name: 'Owner',
      description: 'Full access to all settings, billing, and user management.',
      users: 1,
      permissions: ['All Permissions'],
    },
    {
      name: 'Admin',
      description: 'Can manage members and most settings, but cannot delete the organization.',
      users: 2,
      permissions: ['Manage Users', 'Manage Billing', 'View Reports', 'Edit Profile'],
    },
    {
      name: 'Member',
      description: 'Standard access to organization data and reports.',
      users: 18,
      permissions: ['View Reports', 'View Members'],
    },
  ];

  return (
    <div className='space-y-8'>
      <div className='flex justify-between items-center mb-4'>
        <div>
          <h1 className='text-3xl font-black text-slate-800 tracking-tighter'>Roles & Permissions</h1>
          <p className='text-slate-500 font-medium'>Define what members can see and do within the organization.</p>
        </div>
        <Button label='Create New Role' variant='secondary' className='rounded-xl px-6 py-2.5 font-bold border-emerald-200 text-emerald-600 hover:bg-emerald-50/50' />
      </div>

      <div className='grid grid-cols-1 gap-6'>
        { roles.map((role, i) => (
          <div key={i} className='bg-white rounded-[2rem] border border-slate-100 shadow-sm p-8 hover:shadow-md transition-all'>
            <div className='flex flex-col lg:flex-row justify-between lg:items-center gap-6 mb-8'>
              <div>
                <div className='flex items-center gap-3 mb-2'>
                  <h3 className='text-xl font-black text-slate-800 tracking-tight'>{ role.name }</h3>
                  <span className='px-3 py-1 bg-emerald-50 text-emerald-600 border border-emerald-100 rounded-full text-[10px] font-black uppercase tracking-widest'>
                    { role.users } Users
                  </span>
                </div>
                <p className='text-sm text-slate-500 font-medium tracking-tight max-w-2xl'>{ role.description }</p>
              </div>
              <div className='flex gap-3'>
                <Button label='Edit Role' variant='secondary' className='rounded-xl px-5 py-2 text-xs font-bold border-slate-200' />
                { role.name !== 'Owner' && (
                  <Button label='Duplicate' variant='link' className='text-slate-400 font-bold text-xs' />
                ) }
              </div>
            </div>

            <div className='flex flex-wrap gap-2'>
              { role.permissions.map((permission, j) => (
                <div key={j} className='px-4 py-2 bg-slate-50 border border-slate-100 rounded-xl text-[11px] font-bold text-slate-600 flex items-center gap-2'>
                  <svg className='w-3.5 h-3.5 text-emerald-500' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={3} d='M5 13l4 4L19 7' />
                  </svg>
                  { permission }
                </div>
              )) }
            </div>
          </div>
        )) }
      </div>
    </div>
  );
};

export default PermissionsTab;
